const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookshelf1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 129.75 207.75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.38,
    y: 0.38,
    width: 129,
    height: 207,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 0.38,
    y1: 39.38,
    x2: 129.38,
    y2: 39.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.71,
    y1: 44.38,
    x2: 129.21,
    y2: 44.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 0.38,
    y1: 82.04,
    x2: 129.38,
    y2: 82.04,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.71,
    y1: 87.04,
    x2: 129.21,
    y2: 87.04,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 0.38,
    y1: 124.71,
    x2: 129.38,
    y2: 124.71,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.71,
    y1: 129.71,
    x2: 129.21,
    y2: 129.71,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 0.38,
    y1: 167.38,
    x2: 129.38,
    y2: 167.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.71,
    y1: 172.38,
    x2: 129.21,
    y2: 172.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.71,
    y: 7.88,
    width: 8,
    height: 31,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.71,
    y1: 14.92,
    x2: 11.21,
    y2: 14.92,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.71,
    y: 7.37,
    width: 8,
    height: 31,
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -2.85, 6.06)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.54,
    y1: 15.08,
    x2: 42.96,
    y2: 14.01,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.71,
    y: 12.38,
    width: 8,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.71,
    y1: 18.4,
    x2: 19.21,
    y2: 18.4,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.71,
    y: 12.38,
    width: 6.5,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.71,
    y1: 18.4,
    x2: 74.8,
    y2: 18.4,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.71,
    y: 97.61,
    width: 6.5,
    height: 26.5,
    transform: "translate(-35.79 34.33) rotate(-21.63)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.27,
    y1: 105.34,
    x2: 71.94,
    y2: 103.09,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 97.88,
    width: 6.5,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.71,
    y1: 103.9,
    x2: 24.8,
    y2: 103.9,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.71,
    y: 93.88,
    width: 10.5,
    height: 30.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.71,
    y1: 100.81,
    x2: 35.55,
    y2: 100.81,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.71,
    y1: 105.81,
    x2: 35.55,
    y2: 105.81,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.71,
    y: 93.88,
    width: 10.5,
    height: 30.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.71,
    y1: 100.81,
    x2: 45.55,
    y2: 100.81,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.71,
    y1: 105.81,
    x2: 45.55,
    y2: 105.81,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.71,
    y: 93.88,
    width: 10.5,
    height: 30.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.71,
    y1: 100.81,
    x2: 55.55,
    y2: 100.81,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.71,
    y1: 105.81,
    x2: 55.55,
    y2: 105.81,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.71,
    y: 11.88,
    width: 6.5,
    height: 26.5,
    transform: "translate(5.11 -18.16) rotate(8.55)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.82,
    y1: 17.5,
    x2: 127.85,
    y2: 18.4,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.71,
    y: 97.23,
    width: 6.5,
    height: 26.5,
    transform: "translate(-23.17 16.93) rotate(-12.95)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.17,
    y1: 104.17,
    x2: 64.11,
    y2: 102.8,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76.71,
    y: 15.38,
    width: 6.5,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.71,
    y1: 20.72,
    x2: 82.8,
    y2: 20.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.71,
    y1: 33.72,
    x2: 82.8,
    y2: 33.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.71,
    y: 15.38,
    width: 6.5,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.71,
    y1: 20.72,
    x2: 90.8,
    y2: 20.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.71,
    y: 140.38,
    width: 6.5,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.71,
    y1: 146.4,
    x2: 29.8,
    y2: 146.4,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.71,
    y: 143.38,
    width: 6.5,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.71,
    y1: 148.72,
    x2: 36.8,
    y2: 148.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.71,
    y1: 161.72,
    x2: 36.8,
    y2: 161.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.71,
    y: 143.38,
    width: 6.5,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.71,
    y1: 148.72,
    x2: 43.8,
    y2: 148.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.71,
    y: 55.13,
    width: 6.5,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.71,
    y1: 61.15,
    x2: 9.8,
    y2: 61.15,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.71,
    y: 58.13,
    width: 6.5,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.71,
    y1: 63.47,
    x2: 17.8,
    y2: 63.47,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.71,
    y1: 76.47,
    x2: 17.8,
    y2: 76.47,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.71,
    y: 58.13,
    width: 6.5,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.71,
    y1: 63.47,
    x2: 25.8,
    y2: 63.47,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.71,
    y: 5.38,
    width: 6.5,
    height: 33.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.71,
    y1: 12.99,
    x2: 97.8,
    y2: 12.99,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.71,
    y1: 16.99,
    x2: 97.8,
    y2: 16.99,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.71,
    y: 5.38,
    width: 6.5,
    height: 33.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.71,
    y1: 12.99,
    x2: 104.8,
    y2: 12.99,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.71,
    y1: 16.99,
    x2: 104.8,
    y2: 16.99,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.71,
    y: 5.38,
    width: 6.5,
    height: 33.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.71,
    y1: 12.99,
    x2: 111.8,
    y2: 12.99,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.71,
    y1: 16.99,
    x2: 111.8,
    y2: 16.99,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.71,
    y: 90.88,
    width: 6.5,
    height: 33.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.71,
    y1: 95.49,
    x2: 13.8,
    y2: 95.49,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.71,
    y1: 100.49,
    x2: 13.8,
    y2: 100.49,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.71,
    y: 12.38,
    width: 8,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.71,
    y1: 18.4,
    x2: 27.21,
    y2: 18.4,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.71,
    y1: 22.4,
    x2: 27.21,
    y2: 22.4,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.71,
    y: 15.38,
    width: 8,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.71,
    y1: 20.72,
    x2: 35.21,
    y2: 20.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 115.71,
    y: 93.38,
    width: 8,
    height: 31,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.71,
    y1: 98.42,
    x2: 123.21,
    y2: 98.42,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.71,
    y: 97.88,
    width: 8,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.71,
    y1: 103.9,
    x2: 98.21,
    y2: 103.9,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.71,
    y: 97.88,
    width: 8,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.71,
    y1: 103.9,
    x2: 106.21,
    y2: 103.9,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.71,
    y1: 107.9,
    x2: 106.21,
    y2: 107.9,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.71,
    y: 100.88,
    width: 8,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.71,
    y1: 106.22,
    x2: 114.21,
    y2: 106.22,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.71,
    y: 143.38,
    width: 8,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.71,
    y1: 148.72,
    x2: 61.21,
    y2: 148.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.71,
    y: 140.38,
    width: 8,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.71,
    y1: 146.4,
    x2: 69.21,
    y2: 146.4,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.71,
    y1: 150.91,
    x2: 69.21,
    y2: 150.91,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.71,
    y: 143.38,
    width: 8,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.71,
    y1: 148.72,
    x2: 77.21,
    y2: 148.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.71,
    y1: 161.72,
    x2: 77.21,
    y2: 161.72,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.71,
    y: 58.13,
    width: 8,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.71,
    y1: 63.47,
    x2: 105.21,
    y2: 63.47,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.21,
    y: 55.13,
    width: 9.5,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.21,
    y1: 61.15,
    x2: 62.11,
    y2: 61.15,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.21,
    y1: 65.49,
    x2: 62.11,
    y2: 65.49,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.71,
    y: 51.13,
    width: 9.5,
    height: 30.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.71,
    y1: 58.06,
    x2: 52.61,
    y2: 58.06,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.71,
    y1: 63.06,
    x2: 52.61,
    y2: 63.06,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.71,
    y: 51.13,
    width: 9.5,
    height: 30.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.71,
    y1: 58.06,
    x2: 43.61,
    y2: 58.06,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.71,
    y1: 63.06,
    x2: 43.61,
    y2: 63.06,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 105.71,
    y: 55.13,
    width: 8,
    height: 26.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.71,
    y1: 61.15,
    x2: 113.21,
    y2: 61.15,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.71,
    y1: 65.15,
    x2: 113.21,
    y2: 65.15,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.71,
    y: 58.13,
    width: 8,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.71,
    y1: 63.47,
    x2: 121.21,
    y2: 63.47,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.58,
    y: 147.5,
    width: 8,
    height: 30.75,
    transform: "translate(-62.29 263.46) rotate(-90)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.2,
    y1: 166.88,
    x2: 92.2,
    y2: 159.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.71,
    y: 141.63,
    width: 8,
    height: 26.5,
    transform: "translate(-52.17 257.58) rotate(-90)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.48,
    y1: 158.88,
    x2: 95.48,
    y2: 151.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.48,
    y1: 158.88,
    x2: 99.48,
    y2: 151.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.21,
    y: 135.13,
    width: 8,
    height: 23.5,
    transform: "translate(-42.67 251.08) rotate(-90)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.8,
    y1: 150.88,
    x2: 97.8,
    y2: 143.38,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.71,
    y: 58.13,
    width: 8,
    height: 23.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.71,
    y1: 63.47,
    x2: 91.21,
    y2: 63.47,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76.21,
    y: 50.13,
    width: 4.5,
    height: 31.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.21,
    y1: 57.29,
    x2: 80.43,
    y2: 57.29,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.21,
    y: 135.38,
    width: 4.5,
    height: 31.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.21,
    y1: 142.54,
    x2: 48.43,
    y2: 142.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.21,
    y: 135.38,
    width: 4.5,
    height: 31.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.21,
    y1: 142.54,
    x2: 53.43,
    y2: 142.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.21,
    y: 135.38,
    width: 4.5,
    height: 31.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.21,
    y1: 142.54,
    x2: 8.43,
    y2: 142.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.21,
    y1: 146.54,
    x2: 8.43,
    y2: 146.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.21,
    y: 135.38,
    width: 4.5,
    height: 31.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.21,
    y1: 142.54,
    x2: 13.43,
    y2: 142.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.21,
    y1: 146.54,
    x2: 13.43,
    y2: 146.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.21,
    y: 135.38,
    width: 4.5,
    height: 31.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.21,
    y1: 142.54,
    x2: 18.43,
    y2: 142.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.21,
    y1: 146.54,
    x2: 18.43,
    y2: 146.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.21,
    y: 186.38,
    width: 32,
    height: 21,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.71,
    y: 180.38,
    width: 37,
    height: 6,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.71,
    y: 177.88,
    width: 7,
    height: 29.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.21,
    y1: 183.95,
    x2: 119.46,
    y2: 183.95,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.52,
    y1: 189.17,
    x2: 119.02,
    y2: 189.17,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.71,
    y: 176.88,
    width: 7,
    height: 29.5,
    transform: "translate(22.81 -7.68) rotate(6.68)",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.24,
    y1: 182.66,
    x2: 81.44,
    y2: 183.39,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.94,
    y1: 187.88,
    x2: 80.4,
    y2: 188.52,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.71,
    y: 177.88,
    width: 7,
    height: 29.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.21,
    y1: 183.95,
    x2: 112.46,
    y2: 183.95,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.52,
    y1: 189.17,
    x2: 112.02,
    y2: 189.17,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.71,
    y: 177.88,
    width: 7,
    height: 29.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.21,
    y1: 183.95,
    x2: 105.46,
    y2: 183.95,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.52,
    y1: 189.17,
    x2: 105.02,
    y2: 189.17,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.71,
    y: 177.88,
    width: 7,
    height: 29.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.21,
    y1: 183.95,
    x2: 98.46,
    y2: 183.95,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.52,
    y1: 189.17,
    x2: 98.02,
    y2: 189.17,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.71,
    y: 179.88,
    width: 7,
    height: 27.5,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.21,
    y1: 185.54,
    x2: 91.46,
    y2: 185.54,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.52,
    y1: 203.41,
    x2: 91.02,
    y2: 203.41,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.52,
    y1: 199.41,
    x2: 91.02,
    y2: 199.41,
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookshelf1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bookshelf1.af1fd631914a3e9d6207b209008d0ccd.svg";